import { Trans } from '@lingui/react/macro'
import { Alert, Stack, Text } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'

export function ConsumptionGuidance() {
  return (
    <Alert
      icon={<IconInfoCircle size={20} />}
      title={<Trans>Start consumption tracking</Trans>}
      color="blue"
      variant="light"
    >
      <Stack gap="xs">
        <Text size="sm">
          <Trans>
            Track your electricity, water, and heating consumption using meter
            readings.
          </Trans>
        </Text>
        <Text size="sm" fw={500}>
          <Trans>How to get started:</Trans>
        </Text>
        <Text size="sm" component="ol" ml="md">
          <li>
            <Trans>
              Click the "Add" button on the card you want (electricity, water,
              or heating)
            </Trans>
          </li>
          <li>
            <Trans>
              Enter the current meter reading. This will serve as the starting
              point for consumption calculation.
            </Trans>
          </li>
          <li>
            <Trans>
              You can add an optional cost in euros if you also want to track
              your expenses
            </Trans>
          </li>
          <li>
            <Trans>
              Next time, consumption is calculated automatically: new reading -
              previous reading
            </Trans>
          </li>
        </Text>
      </Stack>
    </Alert>
  )
}
